import * as jQuery from 'jquery';

import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CtvCreativeDetailV3Component } from '../ctv-creative-detail-v3/ctv-creative-detail-v3.component';

@Component({
	selector: 'app-ctv-creative-detail-v4',
	styleUrls: ['./ctv-creative-detail-v4.component.css'],
	templateUrl: './ctv-creative-detail-v4.component.html'
})
export class CtvCreativeDetailV4Component extends CtvCreativeDetailV3Component implements OnInit {
	@Input() tertiarykey;
	@Input() sectiontitle;
	public tableConfig: any;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected colorUtilityService: ColorUtilityService
	) {
		super(analyticsService, analyticsDataModel, cdr, colorUtilityService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.hasData = false;
			this.showLoad = true;
			this.featureLoad = true;
			this.hasFeaturedData = false;
			this.requestData();
			this.requestfeaturedNetworkData();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.requestfeaturedNetworkData();
		this.tableConfig = this.downloadConfiguration;
	}

	updateCampaign(index: number): void {
		this.setDisplayIndexContent(index);
		jQuery('.creative_mask').show();
		jQuery('#preRollvideo')[0].currentTime = 0;
		jQuery('#preRollvideo')[0].play();
		if (jQuery('#preRollvideo')[0]) {
			jQuery('#preRollvideo')[0].autoplay = true;
			jQuery('#percent25, #percent50, #percent75, #percent100').css('opacity', 0.5);
		}
	}

	playclickEvent(): void {
		jQuery('#preRollvideo')[0].play();
		if (jQuery('#preRollvideo')[0].currentTime === 0) {
			jQuery('#percent25, #percent50, #percent75, #percent100').css('opacity', 0.5);
		}
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}
}
